import{iterateChildEntries}from"./children.js";
import{removeDuplicates}from"./duplicate.js";
import{expandRecursiveTokens}from"./recurse.js";


export const iterateQuery=function*(target,queryArrays,opts){
const parents=new Set([]);
const entries=getRootEntries(target,queryArrays);
yield*iterateLevel({entries,index:0,parents,opts})
};

const getRootEntries=(target,queryArrays)=>
queryArrays.map((queryArray)=>({
queryArray,
value:target,
path:[],
missing:false
}));



const iterateLevel=function*({
entries,
entries:[{value,missing}],
index,
parents,
opts
}){
if(missing){
yield*iterateToken({entries,index,parents,opts});
return
}

if(parents.has(value)){
return
}

parents.add(value);
yield*iterateToken({entries,index,parents,opts});
parents.delete(value)
};




const iterateToken=function*({entries,index,parents,opts}){
const entriesA=expandRecursiveTokens(entries,index);
const entriesB=removeDuplicates(entriesA);
const parentEntry=getParentEntry(entriesB,index);

if(shouldYieldParentFirst(parentEntry,opts)){
yield normalizeEntry(parentEntry,opts)
}

const hasChildren=yield*iterateChildEntries({
entries:entriesB,
parentEntry,
index,
parents,
opts,
iterateLevel
});

if(shouldYieldParentLast(parentEntry,hasChildren,opts)){
yield normalizeEntry(parentEntry,opts)
}
};

const getParentEntry=(entries,index)=>
entries.find(({queryArray})=>queryArray.length===index);

const normalizeEntry=({value,path,missing},{entries})=>
entries?{value,path,missing}:value;

const shouldYieldParentFirst=(parentEntry,{childFirst})=>
parentEntry!==undefined&&!childFirst;

const shouldYieldParentLast=(
parentEntry,
hasChildren,
{childFirst,leaves})=>
parentEntry!==undefined&&childFirst&&!(leaves&&hasChildren);